var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chart",staticStyle:{"height":"500px","padding-right":"30px"}})])
}]

export { render, staticRenderFns }